import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import GlowShape from '../components/GlowShape';
import SpeakingFeedbackSection from '../components/SpeakingFeedbackSection';
import InteractionsFeedbackAnalytics from '../components/InteractionsFeedbackAnalytics';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

export default function FeedbackPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-[#060b19] text-white selection:bg-blue-500/30">
      {/* Global background */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(59,130,246,0.12),transparent_32%),radial-gradient(circle_at_top_right,rgba(124,58,237,0.16),transparent_28%),radial-gradient(circle_at_bottom_center,rgba(249,115,22,0.12),transparent_28%)]" />
        <GlowShape className="left-[-4rem] top-20" />
        <GlowShape className="right-[-6rem] top-40" size="w-96 h-96" color="from-purple-500/25 via-blue-500/15 to-transparent" />
      </div>

      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#060b19]/75 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10 lg:px-16">
          <Link to="/" className="flex items-center gap-2 text-sm font-medium text-white/70 hover:text-white transition-colors">
            <SafeIcon icon={FiArrowLeft} className="h-4 w-4" /> Back to Home
          </Link>
          <div className="text-lg font-semibold tracking-wide text-white">Dr. Jeff Robinson</div>
        </div>
      </header>

      <div className="pt-8 pb-20">
        <SpeakingFeedbackSection />
        <InteractionsFeedbackAnalytics />
      </div>
    </main>
  );
}